import { Box, Grid, GridSize } from '@material-ui/core'
import React, { useContext, useState } from 'react'
import buildStyles from './styles'
import { useWindowSize } from '../../../hooks/useWindowSize'
import { MOBILE_WIDTH_HIGH } from '../../../constants/constants'
import AppContext from '../../context'
import Organization from './Organization'
import { OrganizationInfo } from '../../../api/types'
import EntityInfo from '../../../components/popups/entity-info/EntityInfo'
import HeaderInfo from '../../../components/header-info/HeaderInfo'
import { getSize } from '../../../utils/functions'

const OrganizationsView = () => {
  const { state } = useContext(AppContext)

  const [showedOrganization, setShowedOrganization] =
    useState<OrganizationInfo | null>(null)

  const screen = useWindowSize()
  const isMobile: boolean = (screen.width as number) < MOBILE_WIDTH_HIGH

  const count = state.organizations ? state.organizations.length : 0
  const size = getSize(count)

  if (!state.locationDesignConfig) return null

  const styles = buildStyles({
    baseColors: state.locationDesignConfig.baseColors,
  })

  return (
    <>
      <HeaderInfo
        title="Wybierz fundację do wsparcia"
        arrowedTitle="WPŁAĆ DAROWIZNĘ NA WYBRANY CEL"
        addedPadding={!isMobile}
      />

      {state.organizations && state.organizations.length > 0 && (
        <Box
          width="100%"
          margin="0 20px"
          maxWidth="1100px"
          className={styles.container}
        >
          <Grid container alignItems="center" justify="center">
            {state.organizations.map((org, index) => {
              return (
                <Grid
                  key={index}
                  item
                  xs={size[0] as GridSize}
                  sm={size[1] as GridSize}
                  md={size[2] as GridSize}
                  lg={size[3] as GridSize}
                  xl={size[4] as GridSize}
                  className={styles.itemContainer}
                >
                  <Organization
                    organization={org}
                    setShowedOrganization={setShowedOrganization}
                  />
                </Grid>
              )
            })}
          </Grid>
        </Box>
      )}

      {showedOrganization && (
        <EntityInfo
          title={showedOrganization.name}
          subtitle={showedOrganization.description}
          isOpen={!!showedOrganization}
          onClose={() => setShowedOrganization(null)}
          maxWidth="md"
          fullWidth
        />
      )}
    </>
  )
}

export default OrganizationsView
